import * as Yup from 'yup';
import { omit } from 'lodash';

import {
  ApplicationFormFieldsConfig,
  ApplicationFormFieldsSchema,
} from './ApplicationFormModal.types';

export const getResultApplicationFormValues = (
  values: ApplicationFormFieldsSchema,
  fieldsConfig?: ApplicationFormFieldsConfig
) => {
  const paths: Array<keyof ApplicationFormFieldsSchema> = [];

  if (!fieldsConfig?.dealers?.length) {
    paths.push('dealer');
  }

  if (!fieldsConfig?.models?.length) {
    paths.push('model');
  }

  return omit(values, paths) as ApplicationFormFieldsSchema;
};

export const getDefaultValues = (
  options: ApplicationFormFieldsConfig | undefined
): ApplicationFormFieldsSchema => {
  const dealer =
    options?.dealers && options.dealers.length === 1
      ? options.dealers[0]
      : initialApplicationFormValues.dealer;

  return {
    ...initialApplicationFormValues,
    dealer: dealer,
  };
};

export const initialApplicationFormValues: ApplicationFormFieldsSchema = {
  name: '',
  phone: '',
  dealer: { label: '', value: '' },
  model: { label: '', value: '' },
  message: '',
};

export const validationApplicationSchema = (
  fieldsConfig?: ApplicationFormFieldsConfig
): Yup.SchemaOf<ApplicationFormFieldsSchema> => {
  return Yup.object().shape({
    name: Yup.string().required('Укажите имя'),
    phone: Yup.string().required('Укажите номер телефона'),
    model: Yup.object({
      label: Yup.string(),
      value: Yup.string(),
    }).when([], {
      is: () => fieldsConfig?.models && fieldsConfig.models.length !== 0,
      then: Yup.object({
        label: Yup.string().required('Выберите марку автомобиля'),
        value: Yup.string().required('Выберите марку автомобиля'),
      }),
      otherwise: Yup.object({
        label: Yup.string().notRequired(),
        value: Yup.string().notRequired(),
      }),
    }),
    dealer: Yup.object({
      label: Yup.string(),
      value: Yup.string(),
    }).when([], {
      is: () => fieldsConfig?.dealers && fieldsConfig.dealers.length !== 0,
      then: Yup.object({
        label: Yup.string().required('Выберите автоцентр'),
        value: Yup.string().required('Выберите автоцентр'),
      }),
      otherwise: Yup.object({
        label: Yup.string().notRequired(),
        value: Yup.string().notRequired(),
      }),
    }),
    message: Yup.string(),
  }) as Yup.SchemaOf<ApplicationFormFieldsSchema>;
};
